<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import CustomerTable from "../../components/datatables/CustomerTable.vue";

export default {
    page: {
        title: "AR Customer Listing",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "AR Customer Listing",
            items: [
                {
                text: "AR Customer Listing",
                href: "/",
                },
            ],
        };
    },

    methods: {
        // downloadExcel: function () {
        //     // const posting_ = {                
        //     //     key_search: this.key_search
        //     // };

        //     // axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        //     // axios.post(process.env.VUE_APP_AR_API_BASEURL+'export/masterListingExport', posting_, {responseType: 'blob'})
        //     // .then(response => {
        //     //     if (response) {
                    
        //     //         console.log(response);
        //     //         var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        //     //         var fileLink = document.createElement('a');
   
        //     //         fileLink.href = fileURL;
        //     //         fileLink.setAttribute('download', 'Customers Master List.xlsx');
        //     //         document.body.appendChild(fileLink);
   
        //     //         fileLink.click();
        //     //     } 
        //     //     else {
        //     //         this.messageBag = ['No record.'];
        //     //     }
        //     // })
        //     // .catch(error => {
        //     //     this.messageBag = [error.error];
        //     // });
        // },
    },

    components: {
        Layout,
        PageHeader,
        CustomerTable,
    },    
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="card">
            <div class="card-header border-bottom-dashed pb-4">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0">Customer Listing</h5>
                        </div>
                    </div>
                </div>
            </div>
              
            <div class="tab-content text-muted">
                <div class="card-body tab-pane active" id="coldetails" role="tabpanel">
                    <div class="live-preview">
                        <div class="row align-items-center g-12">
                            <div class="col-lg-12">
                                <CustomerTable />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>